export default __webpack_public_path__ + "static/media/ORYX_VariabilityIcon.88e44a53.svg";